import React from 'react'
import PlanEditMonthlyGridShell from './PlanEditMonthlyGridShell'

function PlanEditMonthlyTableShell({
  client,
  epochMonth,
  planId,
  annualHeaderCollapsed,
  onAnnualHeaderCollapsedChange,
  monthlyPlanSettingsId,
  planVersion,
  locationClassId,
  plannerSession,
  weeklyPeriodData,
  onMonthlyEdit,
  onMonthlyContextLoaded,
  onMonthlyBaseUi,
}) {
  const clientId = client?.Id

  return (
    <PlanEditMonthlyGridShell
      clientId={clientId}
      epochMonth={epochMonth}
      planId={planId}
      annualHeaderCollapsed={annualHeaderCollapsed}
      onAnnualHeaderCollapsedChange={onAnnualHeaderCollapsedChange}
      monthlyPlanSettingsId={monthlyPlanSettingsId}
      planVersion={planVersion}
      locationClassId={locationClassId}
      plannerSession={plannerSession}
      weeklyPeriodData={weeklyPeriodData}
      onMonthlyEdit={onMonthlyEdit}
      onMonthlyContextLoaded={onMonthlyContextLoaded}
      onMonthlyBaseUi={onMonthlyBaseUi}
    />
  )
}

export default PlanEditMonthlyTableShell
